import React, { useState, useEffect } from 'react';
import MarkdownText from './MarkdownText';

const TypingEffect = ({ text: rawText, delay = 30, key, prefix='', onNavigate = null }) => {
  const text = rawText || '';
  const [displayedText, setDisplayedText] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    setDisplayedText('');
    setCurrentIndex(0);
  }, [text]);

  useEffect(() => {
    if (currentIndex < text.length) {
      const timer = setTimeout(() => {
        setDisplayedText(prevText => prevText + text[currentIndex]);
        setCurrentIndex(prevIndex => prevIndex + 1);
      }, delay);

      return () => clearTimeout(timer);
    }
  }, [currentIndex, delay, text]);

  return (
    <div>
        <span>{prefix && <strong>{prefix}</strong>}</span>
        <span
            key={key}
            style={{
                // Typography intentionally matches the user-side bubble
                // (ChatInterface 0.9rem, default family). Was monospace
                // 1rem before; that read as visibly larger than the
                // user's messages despite both being nominally 0.9rem.
                fontSize: '0.9rem',
                color: '#777',
                backgroundColor: '#fff',
                padding: '5px',
                borderRadius: '3px',
                display: 'inline-block',
                // inline-block is SHRINK-TO-FIT, and that is what broke the
                // chat on a phone. Shrink-to-fit resolves to
                // max(min-content, min(available, max-content)) — so when the
                // content's MIN-content width exceeds the space available, the
                // min-content width wins and the box grows past its parent.
                //
                // A fenced code block is exactly that content: `white-space:
                // pre` cannot wrap, so its min-content width IS its longest
                // line. A robot program with a 70-column line made this span
                // 598px inside a 290px bubble, and the overflow cascaded all
                // the way out to <body> — the whole page scrolled sideways.
                //
                // The <pre>'s own `overflow-x: auto` never engaged, because a
                // scroll container only scrolls when its width is CONSTRAINED,
                // and its containing block (this span) had grown to fit it.
                // Capping here is what hands the <pre> a bounded width and lets
                // its scrollbar do the job it was always meant to do.
                //
                // border-box because of the 5px padding above: with
                // content-box, `max-width: 100%` still overflows by 10px, and
                // the SPA sets no global box-sizing reset.
                maxWidth: '100%',
                boxSizing: 'border-box',
                whiteSpace: 'pre-wrap',
                // chat-long-token-wrap: the same page-sideways bug, from a long
                // token instead of a code block — a URL has no spaces, so
                // pre-wrap can't break it. `anywhere` lets it break (and, unlike
                // `break-word`, lowers min-content, which this shrink-to-fit span
                // sizes by). `<pre>` stays `white-space: pre` and still scrolls.
                overflowWrap: 'anywhere',
                margin: '3px 0',
            }}
        >
            <MarkdownText text={displayedText} onNavigate={onNavigate} chat />
        </span>
    </div>
  );
};

export default TypingEffect;